<template>
  <div
    :class="[variance, { 'has-errors': error.length > 0 }]"
    class="custom-radio-buttom-container selector-control"
  >
    <div
      v-for="(item, index) in options"
      :key="'rbQuestion' + index"
      @click="checkButton(item, `rbgInput${contextId}${index}`)"
    >
      <div class="page-item">
        <div
          class="page-link custom-radio-buttom"
          :class="{ 'has-errors': error.length > 0, disabled: disabled }"
          :style="onApplyBackground(item)"
        >
          <label
            :for="`rbgInput${contextId}${index}`"
            class="d-block text-center text-dark"
          >
            {{ getNumber(index) }}
          </label>
          <div class="input-group text-center">
            <input
              :id="`rbgInput${contextId}${index}`"
              v-model="selectedAnswer"
              type="radio"
              :disabled="disabled"
              :value="item"
              :name="`rbgNumber${contextId}`"
            />
            <div class="circle-checkmark d-flex justify-content-center">
              <div class="checkmark align-self-center" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomRadioButtons',
  data() {
    return {
      selectedAnswer: this.value,
    };
  },
  computed: {
    getNumber() {
      return (index) => index + 1;
    },
  },
  props: {
    contextId: {
      type: Number,
      default: () => 1,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {},
    },
    error: {
      type: String,
      default: () => new String(),
    },
    variance: {
      type: String,
      default: () => new String(),
    },
  },
  methods: {
    checkButton(value, buttonId) {
      if (this.disabled === false) {
        document.getElementById(buttonId).checked = true;
        this.$emit('input', value);
      }
    },
    onApplyBackground(item) {
      if (item.value == this.selectedAnswer?.value) {
        return { background: item.color };
      }
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
};
</script>

<style scoped>
.custom-radio-buttom-container {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-right: 1px;
  margin-right: -10px;
  margin-top: 3px;
  margin-bottom: 0px;
}

.custom-radio-buttom-container input {
  visibility: hidden;
  position: absolute;
}

.custom-radio-buttom {
  background-color: transparent;
  width: 52px;
}

.custom-radio-buttom,
.custom-radio-buttom label,
.custom-radio-buttom input {
  cursor: pointer;
}

.custom-radio-buttom.disabled,
.custom-radio-buttom.disabled label,
.custom-radio-buttom.disabled input {
  cursor: default;
}

.custom-radio-buttom.disabled:hover {
  background-color: #f8f8f8;
}

.disabled {
  background-color: #f8f8f8;
}

.circle-checkmark {
  border: 1px solid rgba(60, 60, 60, 0.26);
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-left: 3px;
  background: #fff;
}

.checkmark {
  height: 80%;
  width: 80%;
  border-radius: 50%;
}

.checkmark:after {
  content: '';
  display: none;
}

.custom-radio-buttom input:checked ~ .circle-checkmark > .checkmark {
  background: #2db782;
}

.custom-radio-buttom-container.has-errors {
  border: 1px solid #c9545e;
  border-radius: 5px;
}

.custom-radio-buttom.has-errors {
  background-color: #ffebeb;
}
</style>
